import React from 'react';
import {
	Typography,
} from '@mui/material';

const Title = ({ children, sx = {} }) => (
	<Typography sx={{ color: 'primary.main', p: 2, fontWeight: 900, textAlign: 'center', fontSize: '24px', textTransform: 'uppercase', ...sx }}>
    {children}
  </Typography>
);

export default Title;